import { Link } from "react-router";
import type { StationOrProcedure } from "../../../../../api/spark";
import Text from "../../../../../design-system/primitives/components/Text/Text";
import styles from "./ModuleLink.css";

interface ModuleLinkProps {
  module: StationOrProcedure;
  baseUrl: string;
  disableSome: boolean;
}

const getModuleUrl = (module: StationOrProcedure, baseUrl: string): string => {
  if (module.type === "station") {
    const firstStep = module.steps[0];
    return firstStep ? `${baseUrl}/step/${firstStep.slug}` : "";
  }
  return `${baseUrl}/step/${module.slug}`;
};

export const ModuleLink = ({
  module,
  baseUrl,
  disableSome,
}: ModuleLinkProps) => {
  const disabled = disableSome && module.disabled;
  const duration = module.recommendedMinutes;

  const content = (
    <>
      {duration ? (
        <div className={styles.badge}>
          <Text variant="label" color="neutral-0">{`${duration}'`}</Text>
        </div>
      ) : (
        <div className={styles.badgeSpacer} />
      )}
      <div className={styles.titleWrap}>
        <Text variant="body" color="neutral-0">
          {module.title}
        </Text>
      </div>
    </>
  );

  if (disabled) {
    return (
      <div className={styles.rowDisabled} role="link" aria-disabled="true">
        {content}
      </div>
    );
  }

  return (
    <Link
      to={getModuleUrl(module, baseUrl)}
      className={styles.row}
      data-cy="cy-workshopansicht-modul-link"
    >
      {content}
    </Link>
  );
};
